import React from 'react';
import GrammarPageLayout from '../components/grammar-page-layout';
import GrammarExplanation from './adverbs-of-frequency-explanation';

const mainimage = '/Images/1person1.webp';

const sections = [
  { label: "Grammar", description: "Do this exercise to practice adverbs of frequency.", type: "quiz", subtype: "adverbs-of-frequency" },
];

const AdverbsOfFrequency = () => (
  <GrammarPageLayout
    level="A1"
    title="Adverbs of Frequency"
    image={mainimage}
    ExplanationComponent={GrammarExplanation}
    sections={sections}
    seoTitle="Free English Adverbs of Frequency Exercises"
    seoDescription="Practice adverbs of frequency (always, usually, often, sometimes, rarely, never) and frequency expressions (once a week, every day, etc.). A1 level grammar exercises."
    relatedCategory="grammar-exercises"
    relatedLevel="A1"
  />
);

export default AdverbsOfFrequency;